// ============================================================
// Claim links for partner-managed orgs — /v1/auth/claims (public).
// The dashboard's /claim/:token page (modules/claim/ClaimPage.tsx).
// ============================================================

import type { APIResponse } from '@yourownmetric/shared'

import { apiSlice } from './apiSlice'
import type { SessionResponse } from './teamApi'

export interface ClaimPreview {
    orgId: string
    orgName: string
    partnerName: string
    email: string
    expiresAt: string
    status: 'pending' | 'used' | 'expired' | 'claimed'
    accountExists: boolean
    returnOrigin: string
}

export type ClaimResult = SessionResponse & { orgId: string; returnOrigin: string }

export const claimApi = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getClaimPreview: builder.query<ClaimPreview, string>({
            query: token => `/auth/claims/${encodeURIComponent(token)}`,
            transformResponse: (r: APIResponse<ClaimPreview>) => r.data!,
        }),
        acceptClaim: builder.mutation<
            ClaimResult,
            { token: string; name?: string; password?: string }
        >({
            query: body => ({ url: '/auth/claims/accept', method: 'POST', body }),
            transformResponse: (r: APIResponse<ClaimResult>) => r.data!,
        }),
    }),
})

export const { useGetClaimPreviewQuery, useAcceptClaimMutation } = claimApi
